__turbopack_context__.v({
  "aria-live-text": "SCPrsq_aria-live-text",
  "cropper": "SCPrsq_cropper",
  "cropper__image": "SCPrsq_cropper__image",
  "wrapper": "SCPrsq_wrapper",
});
